<claas-dialog-modal
  [title]="'changeCountryDialog.title' | translate"
  [showCloseButton]="false"
  [isModal]="true"
  [size]="modalSize"
>
  <div class="country-list">
    @for (country of store.availableCountries(); track country) {
      <button
        type="button"
        class="country-item"
        [class.country-item--selected]="country === selectedCountry()"
        (click)="select(country)"
      >
        {{ "country." + country | translate }}
      </button>
    }
  </div>
  <div class="dialog-footer">
    <claas-button
      [buttonClass]="buttonClass.SECONDARY_OUTLINE"
      (click)="cancel()"
      >{{ "dialogButtons.cancel" | translate }}</claas-button
    >
    <claas-button [buttonClass]="buttonClass.PRIMARY" (click)="confirm()">{{
      "dialogButtons.confirm" | translate
    }}</claas-button>
  </div>
</claas-dialog-modal>
